// ABOUTME: Ensures the entry keyed by the target languageIsoCode in a multi-language name
// ABOUTME: array carries the value resolved with locale-priority base-subtag matching.
import { getNameByLocale } from '@src/utils/hierarchies/getNameByLocale';

type NameEntry = { languageIsoCode: string; value: string };

// The data-table library resolves display names with an exact `.find` on the target
// language. This rewrites the array so that exact lookup hits the value resolved with
// the given language priority list (e.g. [browser locale, default language]), mirroring
// how editNode resolves labels via getNameByLocale.
export const ensureNameForLanguage = (
    names: NameEntry[] | null | undefined,
    targetLanguage: string,
    languages: string[] = [targetLanguage],
): NameEntry[] => {
    const list = names ?? [];
    const resolved = getNameByLocale(list, languages);
    // No localized name matched → leave untouched so the library falls back to code.
    if (!resolved) return list;
    // The entry the exact lookup will hit already carries the resolved value.
    if (list.find(n => n.languageIsoCode === targetLanguage)?.value === resolved) return list;
    return [{ languageIsoCode: targetLanguage, value: resolved }, ...list];
};

export default ensureNameForLanguage;
